let active = false;
const listeners = new Set<() => void>();

export function setWorkoutActive(value: boolean): void {
  active = value;
  for (const fn of listeners) fn();
}

export function isWorkoutActive(): boolean {
  return active;
}

export function onWorkoutActiveChange(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
